__turbopack_context__.v({
  "assetImage": "monthly-media-module__0QEO_a__assetImage",
  "checkReveal": "monthly-media-module__0QEO_a__checkReveal",
  "liveAvatar": "monthly-media-module__0QEO_a__liveAvatar",
  "liveBadge": "monthly-media-module__0QEO_a__liveBadge",
  "liveBubble": "monthly-media-module__0QEO_a__liveBubble",
  "liveCamera": "monthly-media-module__0QEO_a__liveCamera",
  "liveFirstMessage": "monthly-media-module__0QEO_a__liveFirstMessage",
  "liveMessage": "monthly-media-module__0QEO_a__liveMessage",
  "livePhoto": "monthly-media-module__0QEO_a__livePhoto",
  "liveQuestion": "monthly-media-module__0QEO_a__liveQuestion",
  "liveShade": "monthly-media-module__0QEO_a__liveShade",
  "liveSignal": "monthly-media-module__0QEO_a__liveSignal",
  "liveStack": "monthly-media-module__0QEO_a__liveStack",
  "liveThumbnail": "monthly-media-module__0QEO_a__liveThumbnail",
  "liveTyping": "monthly-media-module__0QEO_a__liveTyping",
  "media": "monthly-media-module__0QEO_a__media",
  "offerAvatar": "monthly-media-module__0QEO_a__offerAvatar",
  "offerPill": "monthly-media-module__0QEO_a__offerPill",
  "progressFill": "monthly-media-module__0QEO_a__progressFill",
  "progressOrbit": "monthly-media-module__0QEO_a__progressOrbit",
  "progressVisibility": "monthly-media-module__0QEO_a__progressVisibility",
  "recapBadge": "monthly-media-module__0QEO_a__recapBadge",
  "recapDetail": "monthly-media-module__0QEO_a__recapDetail",
  "recapFeed": "monthly-media-module__0QEO_a__recapFeed",
  "recapFill": "monthly-media-module__0QEO_a__recapFill",
  "recapFoot": "monthly-media-module__0QEO_a__recapFoot",
  "recapHeading": "monthly-media-module__0QEO_a__recapHeading",
  "recapIcon": "monthly-media-module__0QEO_a__recapIcon",
  "recapProgress": "monthly-media-module__0QEO_a__recapProgress",
  "recapProgressVisibility": "monthly-media-module__0QEO_a__recapProgressVisibility",
  "recapRow": "monthly-media-module__0QEO_a__recapRow",
  "recapScroll": "monthly-media-module__0QEO_a__recapScroll",
  "recapText": "monthly-media-module__0QEO_a__recapText",
  "recapViewport": "monthly-media-module__0QEO_a__recapViewport",
  "ringBreath": "monthly-media-module__0QEO_a__ringBreath",
  "scene": "monthly-media-module__0QEO_a__scene",
  "typingDot": "monthly-media-module__0QEO_a__typingDot",
  "typingWindow": "monthly-media-module__0QEO_a__typingWindow",
  "updateCheck": "monthly-media-module__0QEO_a__updateCheck",
  "updateFirstStage": "monthly-media-module__0QEO_a__updateFirstStage",
  "updateIcon": "monthly-media-module__0QEO_a__updateIcon",
  "updateLabel": "monthly-media-module__0QEO_a__updateLabel",
  "updateLive": "monthly-media-module__0QEO_a__updateLive",
  "updateMedal": "monthly-media-module__0QEO_a__updateMedal",
  "updateOrbit": "monthly-media-module__0QEO_a__updateOrbit",
  "updatePill": "monthly-media-module__0QEO_a__updatePill",
  "updateProgress": "monthly-media-module__0QEO_a__updateProgress",
  "updateProgressGroup": "monthly-media-module__0QEO_a__updateProgressGroup",
  "updateRipples": "monthly-media-module__0QEO_a__updateRipples",
  "updateStage": "monthly-media-module__0QEO_a__updateStage",
  "updateState": "monthly-media-module__0QEO_a__updateState",
  "updateStroke": "monthly-media-module__0QEO_a__updateStroke",
});
